/* eslint-disable no-console */
import YouboraInfinity from './infrastructure/providers/YouboraInfinity';
import GoogleTagManager from './infrastructure/providers/GoogleTagManager';
import { getNewEventDefaults } from './infrastructure/newEventDefaults';

function MetricsInstance() {
  const youboraInstance = new YouboraInfinity();
  const googleTagManagerInstance = new GoogleTagManager();

  const start = session => {
    try {
      youboraInstance.pluginInitialize(session);
    } catch (error) {
      console.debug(error);
    }
  };

  const stop = () => {
    try {
      youboraInstance.pluginStop();
    } catch (error) {
      console.debug(error);
    }
  };

  const newEvent = event => {
    try {
      const defaults = getNewEventDefaults();

      const eventWithDefaults = {
        ...event,
        ...defaults,
      };

      youboraInstance.fireEvent(eventWithDefaults);
      googleTagManagerInstance.pushEvent(eventWithDefaults);
    } catch (error) {
      console.debug(error);
    }
  };

  const navigationEvent = navEvent => {
    try {
      youboraInstance.fireNav(navEvent);
      googleTagManagerInstance.pushNavigation(navEvent);
    } catch (error) {
      console.debug(error);
    }
  };

  const newSession = session => {
    try {
      youboraInstance.newSession(session);
    } catch (error) {
      console.debug(error);
    }
  };

  return {
    start,
    stop,
    newEvent,
    navigationEvent,
    newSession,
    youboraInstance,
  };
}

const Metrics = new MetricsInstance();

export default Metrics;
